import React from "react";
import ImageWithFallback from "./ImageWithFallback";
import './App.css';

const HappyDiwali = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Happy Diwali</h1>
        <p>Celebrate the festival of lights with this beautiful Diwali animation.</p>
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/happy_diwali.gif" 
            alt="Happy Diwali" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project creates a beautiful Diwali celebration animation using Python code.</p>
        <h2>Download</h2>
        <a href="/happy_dipawali_diwali.py" download>Download happy_dipawali_diwali.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to see the Diwali animation.</p>
      </div>
    </div>
  );
};

export default HappyDiwali;
